import { Calendar } from "@/components/ui/calendar";
import { X } from "lucide-react";

export const isoDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromIso = (s) => new Date(`${s}T12:00:00`);
export const shortDay = (s) => fromIso(s).toLocaleDateString("it-IT", { weekday: "short", day: "2-digit", month: "2-digit" });

export function MultiDatePicker({ value, onChange, locked = [], noPast = false, hint = "Puoi scegliere giorni anche non consecutivi. Ogni giorno comparirà nell'agenda del tecnico." }) {
  const sorted = [...value].sort();
  const select = (days) => {
    const next = (days || []).map(isoDay);
    onChange([...new Set([...next, ...locked])].sort());
  };
  return (
    <div className="grid gap-4 md:grid-cols-[auto_1fr]" data-testid="multi-date-picker">
      <Calendar mode="multiple" selected={value.map(fromIso)} onSelect={select} weekStartsOn={1} disabled={noPast ? { before: new Date(new Date().setHours(0, 0, 0, 0)) } : undefined} className="rounded-xl border" />
      <div>
        <p className="text-sm font-medium" data-testid="multi-date-count">{sorted.length ? `${sorted.length} giorni selezionati` : "Seleziona i giorni sul calendario"}</p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {sorted.map((d, i) => (
            <span key={d} className="inline-flex items-center gap-1 rounded-full bg-[#eef5e4] px-2.5 py-1 text-xs font-medium capitalize text-[#3d6b16]" data-testid={`multi-date-chip-${i}`}>
              {shortDay(d)}
              {!locked.includes(d) && <button type="button" onClick={() => onChange(sorted.filter((x) => x !== d))} aria-label="Rimuovi" data-testid={`multi-date-remove-${i}`}><X className="h-3 w-3" /></button>}
            </span>
          ))}
        </div>
        <p className="mt-3 text-xs text-slate-500">{hint}</p>
      </div>
    </div>
  );
}
